import React from 'react'
import './Governer.css'
import Card from '../Card/Card'
import data from './Governer'
import { width } from '@fortawesome/free-brands-svg-icons/fa42Group'
function Advisors() {
    return (
        <>
            <div style={{ width: '100%' , textAlign: 'center', paddingTop: '20px' }}>
                <h2>Executive Committee Members</h2>
            </div>
            <div className="Governer_container">
                {data.map((data, index) => (
                    <Card key={index} name={data.name} position={data.position} ImageUrl={data.ImageUrl} facebookLink={data.facebookLink} linkedinLink={data.linkedinLink} InstagramLink={data.InstagramLink} />
                ))}

            </div>
        </>
    )
}

export default Advisors;